import React, { useEffect } from "react";
import { SESSION_KEY } from "../const/AppConst";
import {  setSessionStorage } from "../utils/utils";
import { AppAction, AppReducer, AppState, initialState } from "./reducers/AppReducer";

type AppContextProps = {
    state: AppState;
    dispatch: React.Dispatch<AppAction>;
  };

const AppContext = React.createContext<AppContextProps>({
  state: initialState,
  dispatch: () => initialState,
});

export function AppProvider(props: React.PropsWithChildren<{}>) {
    const [state, dispatch] = React.useReducer(AppReducer, initialState);
    useEffect(() => {
      setSessionStorage(SESSION_KEY, state);
    }, [state]);
  
    return <AppContext.Provider value={{ state, dispatch }} {...props} />;
}

export default function useAppState() {
    const context = React.useContext(AppContext);
    if (!context) {
      throw new Error(`useAppState must be used within an AppProvider`);
    }
    return context;
}

